@for (component of menuComponents(); track component.id) {
    <div
        class="absolute bottom-0 h-0 overflow-visible"
        interactaResize
        [class]="componentsClassesMap[component.id]"
        [id]="component.id"
        [ngStyle]="{
            right: componentsRightMap()[component.id],
        }"
        [resizeAxis]="'width'"
        (changeSize)="onChangeResize(component.id, $event)"
    >
        <ng-container *ngComponentOutlet="component.type" />
    </div>
}
